import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';

export function useFeatures() {
    const page = usePage();

    return {
        isVigilanceEnabled: computed(() => page.props.features?.vigilance ?? true),
        isDofEnabled: computed(() => page.props.features?.dof ?? true),
        isDbeEnabled: computed(() => page.props.features?.dbe ?? true),
        isAuditEnabled: computed(() => page.props.features?.audit ?? true),
        isSubscriptionEnabled: computed(() => page.props.features?.subscription ?? false),
    };
}
